import NavbarBottomAdmin from './components/navbarBottomAdmin'
import NavbarTopAdmin from './components/navbarTopAdmin'
import AuthProvider from '../Authentication/authProvider'
import axios from 'axios'
import { useEffect, useState } from 'react'

function Converter() {

    const [foto, setFormData] = useState({ foto: null, nomeFoto: null })

    const [msg, setMsg] = useState(null)

    async function imageChange(e) {
        setMsg(null)
        if (e.target.files[0]) {
            const fileImg = e.target.files[0]
            if (fileImg.type === "image/png" || fileImg.type === "image/jpeg") {
                // ------ ACCETTAZIONE IMMAGINE ----------------------------------------  
                setFormData({ ...foto, foto: fileImg, nomeFoto: fileImg.name })
            } else {
                //immagine type non conforme
                setMsg('Tipo immagine non conforme')
                e.target.value = ""; setFormData({ foto: null, nomeFoto: null }); return
            }
        }
    }
    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        if (foto) {
            try {
                const fd = new FormData()
                fd.append('foto', foto.foto); fd.append('nomeFoto', foto.nomeFoto); fd.append('stato','noAwsBucket')
                const res = await axios.post('/convertJpegBase64', fd, {
                    headers: { "Content-Type": "multipart/form-data" }
                })
                if (res.data === 'success') setMsg("Foto salvata in cartella server/controllers/uploads")
            } catch (err) { console.log(err) }
        }
    }

    useEffect(() => { console.log(foto) }, [foto])
    return (<>
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <AuthProvider />
        <div className='container'><br /><br />
            <h2 className='text-center mt-5' style={{ color: 'navy' }}>Image compression</h2>
            <br /><hr />
            <div className='mt-2'>
                <form onSubmit={handleSubmit}>
                    <input
                        type='file'
                        name='foto'
                        accept="image/png, image/gif, image/jpeg"
                        onChange={imageChange} />
                    <div className='mt-3'>
                        {foto.foto &&
                            // --------- PREVIEW IN BASE64 ------------     
                            <img src={URL.createObjectURL(foto.foto)} width={200} height={180} alt="" />
                        }
                        <p>{foto.nomeFoto}</p>
                        {msg && <p style={{ color: 'red' }}>{msg}</p>}
                    </div><hr />
                    <button type='submit' style={{ float: 'right' }} className='btn btn-primary'>Avanti</button>
                </form>
            </div>
        </div>
    </>)
}
export default Converter